import { useDeepSignal } from 'deepsignal';
import { CHARITY } from '@util/const.js';
import {
  useDeepSignalFromLocalStorage,
  useSignalWithLocalStorage,
} from '@util/deepSignals.js';

const defaultConfig = {
  charityType: CHARITY.TILTIFY,
  minAmount: 1,
  maxAmount: 1000,
  maxBalls: 25,
  maxScale: 15,
  randomColors: 'no',
  scaleSize: 'yes',
  showNames: 'yes',
  startSize: 1,
  showAllDonations: 'no',
  frictionAir: 0.01,
  frictionStatic: 0.5,
  friction: 0.0006,
  restitution: 0.8,
  mass: 1000,
  density: 0.001,
  clampVelocity: 12,
  clampAngularSpeed: 0.03,
  ballPitType: 'default',
  explosionForceMagnitude: 0.025,
};

export default function useBallPitOverlayConfig() {
  const config = useDeepSignal({ ...defaultConfig });
  useDeepSignalFromLocalStorage(config);
  const setConfigState = useSignalWithLocalStorage(config);

  return {
    config,
    setConfigState,
    resetToDefault: () => {
      Object.keys(defaultConfig).forEach((key) => {
        config[key] = defaultConfig[key];
        localStorage.setItem(key, defaultConfig[key]);
      });
    },
  };
}
